import { faDownload } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import { Button, Form } from "../../../../components";
import { showAlert, hideAlert } from "../../../../components/alert/Alert";
import { TextField } from "../../../../components/fields";
import { AlertTypeEnum } from "../../../../enums";
import asyncify from "../../../../utilities/asyncify";
import downloadBase64File, { errorAlert } from "../../../../utilities/fileUtil";
import { goFetch } from "../../../../utilities/goFetch";
import Heading from "../heading/Heading";
import "./_styles.scss";

interface ViewItemProps {
  data?: any;
}

export default function ViewItem({ data }: ViewItemProps) {
  const [buyers, setBuyers] = useState<any[]>([]);

  const getAllUserById = async () => {
    var response: any = await goFetch(`user/buyers`).get();
    var jsonResponse = await response.json();

    setBuyers(jsonResponse.buyers);
  };
  useEffect(() => {
    getAllUserById();
    return () => {};
  }, []);
  const hidden = true;
  return (
    <div className="access-item">
      <Heading {...data} />
      <Form title="Request Details">
        <TextField label="Buyer Request Status" value={data.status} readOnly />
        {!hidden && (
          <TextField
            label="Supplier Name"
            value={data.supplierName}
            readOnly
            hidden={true}
          />
        )}
      </Form>

      <Form title="Buyer Details">
        {buyers
          .filter((e: any) => e.id === data.buyerId)
          .map((buyer: any) => (
            <>
              <TextField
                label="Buyer Trading Name"
                value={buyer.buyerTradingName}
                readOnly
              />
              <TextField label="Buyer Email" value={buyer.email} readOnly />

              <Form title="Buyer Delivery Address">
                <TextField
                  label="Adress Line 1"
                  value={buyer.dAddressLine1}
                  readOnly
                />
                <TextField
                  label="Adress Line 2"
                  value={buyer.dAddressLine2}
                  readOnly
                />
                <TextField
                  label="Adress Line 2"
                  value={buyer.dAddressLine1}
                  readOnly
                />
                <TextField label="Area Code" value={buyer.dAreaCode} readOnly />
                <TextField label="Town" value={buyer.dTown} readOnly />
                <TextField label="County" value={buyer.dCounty} readOnly />
                <TextField
                  label="Buyer Proof of Address"
                  value={
                    buyer.proofOfAddress === "" || buyer.proofOfAddress === null
                      ? "No File"
                      : "Proof of Address"
                  }
                  readOnly
                  name="proofOfAddress"
                  endAdornment={
                    <Button
                      icon={faDownload}
                      primary
                      onClick={(_) =>
                        asyncify(
                          () =>
                            buyer.proofOfAddress === "" ||
                            buyer.proofOfAddress === null
                              ? errorAlert()
                              : downloadBase64File(
                                  buyer.proofOfAddress,
                                  "ProofofAddress.pdf"
                                ),
                          0
                        )
                      }
                      className="clear-button"
                    />
                  }
                />
              </Form>
              <Form title="Buyer Company Details">
                <TextField
                  label="Company Registration Number"
                  value={buyer.companyRegNo}
                  readOnly
                />
                <TextField
                  label="Company Registration Document"
                  value={
                    buyer.regDocument === ""
                      ? "No File"
                      : "Company Registration Document"
                  }
                  readOnly
                  name="regDocument"
                  endAdornment={
                    <Button
                      icon={faDownload}
                      primary
                      onClick={(_) =>
                        asyncify(
                          () =>
                            buyer.regDocument === "" ||
                            buyer.regDocument === null
                              ? errorAlert()
                              : downloadBase64File(
                                  buyer.regDocument,
                                  "RegDocument.pdf"
                                ),
                          0
                        )
                      }
                      className="clear-button"
                    />
                  }
                />
                <TextField
                  label="Company VAT Registration Number "
                  value={buyer.companyVATRegNo}
                  readOnly
                />
                <TextField
                  label="Company VAT Registration Document"
                  value={
                    buyer.vatRegDocument === "" || buyer.vatRegDocument === null
                      ? "No File"
                      : "Company VAT Registration Document"
                  }
                  readOnly
                  name="vatRegDocument"
                  endAdornment={
                    <Button
                      icon={faDownload}
                      primary
                      onClick={(_) =>
                        asyncify(
                          () =>
                            buyer.vatRegDocument === "" ||
                            buyer.vatRegDocument === null
                              ? errorAlert()
                              : downloadBase64File(
                                  buyer.vatRegDocument,
                                  "VatRegDocument.pdf"
                                ),
                          0
                        )
                      }
                      className="clear-button"
                    />
                  }
                />
              </Form>
            </>
          ))}
      </Form>
    </div>
  );
}
